
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { I18nProvider } from './i18n/i18nProvider';
import ErrorBoundary from './components/ErrorBoundary';
import { initUIXTelemetry } from './services/telemetry';
import { UIX_CONFIG } from './config';
import './index.css';

import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './AppContext';

// Initialize UIX-specific OpenTelemetry Logging (registers with Shared)
initUIXTelemetry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <I18nProvider>
        <AppProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AppProvider>
      </I18nProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
